	<script>
		let img = "/components_dash/dist/img/favicon ratingg.png";
	</script>
	<!-- Preloader -->
	<div class="preloader flex-column justify-content-center align-items-center">
	  <img class="animation__shake" src={img} alt="AdminLTELogo" height="60" width="60">
	</div>

